import { cn } from '../lib/utils';

/**
 * Links to the Privacy Policy and Terms of Service. They live on the marketing site,
 * so the apps link to its PRODUCTION address on every deployment (DEV never has its own
 * copy of the legal text). Opened in a new tab so nobody loses a half-filled form.
 */
const PRIVACY_URL = 'https://closingvault.app/privacy/';
const TERMS_URL = 'https://closingvault.app/terms/';

const LINK = 'underline underline-offset-2 hover:text-foreground';

/** "Privacy · Terms", the small footer line under a sign-in or sign-up card. */
export function LegalLinks({ className }: { className?: string }) {
  return (
    <p className={cn('text-center text-xs text-muted-foreground', className)}>
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className={LINK}>
        Privacy
      </a>
      {' · '}
      <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className={LINK}>
        Terms
      </a>
    </p>
  );
}

/** The line under the create-account button. Agreement by creating the account; no checkbox. */
export function SignUpAgreement({ className }: { className?: string }) {
  return (
    <p className={cn('text-center text-xs text-muted-foreground', className)}>
      By creating an account you agree to the{' '}
      <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className={LINK}>
        Terms
      </a>{' '}
      and{' '}
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className={LINK}>
        Privacy Policy
      </a>
      .
    </p>
  );
}
